export default __webpack_public_path__ + "static/media/ic_info_warning.6dfe02b6.svg";